import { useState, useEffect } from "react"
import { Button, ButtonGroup } from "react-bootstrap"
import "./GridCompany.scss"
import { Company } from "../../../utils/models/Company"
import { useTranslation } from "react-i18next"
import { Spinner } from "react-bootstrap"
import { DataGrid } from "aw-data-grid"
import { ColumnFiltersState, createColumnHelper, PaginationState, SortingState } from "@tanstack/react-table"

const GridCompany = (props: { companies: Company[]; onEditClick: (c: Company) => void; onDeleteClick: (c: Company) => void; loading: boolean,   globalFilter: any, onGlobalFilterChange: React.Dispatch<React.SetStateAction<any>> }) => {
    const { t } = useTranslation()
    const [companies, setCompanies] = useState<Company[]>(props.companies)

    useEffect(() => {
        setCompanies(props.companies.sort((a, b) => a.idcompany - b.idcompany))
    }, [props.companies])
    
    const columnHelper = createColumnHelper<Company>()
    const columns = [
        columnHelper.accessor("name", {
            header: t("Name"),
            cell: (info) => info.getValue()
        }),
        columnHelper.accessor("email", {
            header: t("Email"),
            cell: (info) => info.getValue()
        }),
        columnHelper.accessor("address", {
            header: t("Address"),
            cell: (info) => info.getValue()
        }),
        columnHelper.accessor("city", {
            header: t("City"),
            cell: (info) => info.getValue()
        }),
        columnHelper.accessor("country", {
            header: t("Country"),
            cell: (info) => info.getValue()
        }),
        columnHelper.display({
            id: "actions",
            header: "",
            enableSorting: false,
            enableColumnFilter: false,
            cell: ({ row }) => {
                const c = row.original as Company
                return (
                    <div className="text-end">
                        <ButtonGroup>
                            <button onClick={(e) => {e.stopPropagation();props.onDeleteClick(c)}} className='btn-Simple text-danger '><i className="bi bi-trash"></i></button>
                        </ButtonGroup>
                    </div>
                )
            }
        })
    ]
    

    // drama drama amb el never
    return (
        <div className='p-2 rounded-1' id='gridCompanyContainer'>
            {props.loading ? (
                <div className='text-center pt-5'>
                    <Spinner animation='border' variant='success' />
                </div>
            ) : companies.length > 0 ? (
                <div className='table-responsive scrollCompany'>
                    <DataGrid data={companies} columns={columns} filtersPlaceholder={t('Search')}  paginationEnabled={false} globalFilter={props.globalFilter} onGlobalFilterChange={props.onGlobalFilterChange} onRowClick={(company) => props.onEditClick(company)}  />
              
                </div>
            ) : (
                <p className='text-center'>{t("NoCompanies")}</p>
            )}
        </div>
    )
}

export default GridCompany
